import { Venue, VenueGetVenueQuery } from '../../graphql/API';
import { venueGetVenue } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const venueGetVenueApi = async (id: string): Promise<Venue> => {
  const result = await executeGql<VenueGetVenueQuery>(venueGetVenue, { id });
  return processGqlResult<Venue>('venueGetVenue', result);
};
